/**
 * @generated SignedSource<<b6b426beda34867cf79b4e379e3300f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MusicUpdatePieceFileChangeMIDINoteAndStartInput = {
  bulb_id: string;
  midi_number: number;
  note_start: number;
  piece_id: string;
};
export type UpdatePieceFileChangeMIDINoteAndStartMutation$variables = {
  input: MusicUpdatePieceFileChangeMIDINoteAndStartInput;
};
export type UpdatePieceFileChangeMIDINoteAndStartMutation$data = {
  readonly music_update_piece_file_change_midi_note_and_start: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PiecePlayBody_piece">;
    };
  };
};
export type UpdatePieceFileChangeMIDINoteAndStartMutation = {
  variables: UpdatePieceFileChangeMIDINoteAndStartMutation$variables;
  response: UpdatePieceFileChangeMIDINoteAndStartMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePieceFileChangeMIDINoteAndStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MusicPieceOutput",
        "kind": "LinkedField",
        "name": "music_update_piece_file_change_midi_note_and_start",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PiecePlayBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePieceFileChangeMIDINoteAndStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MusicPieceOutput",
        "kind": "LinkedField",
        "name": "music_update_piece_file_change_midi_note_and_start",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "output_storage_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicPieceFile",
                "kind": "LinkedField",
                "name": "file",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MusicPieceFileNote",
                    "kind": "LinkedField",
                    "name": "notes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bulb_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "left_handed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note_start",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "midi_number",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note_duration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "page_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pitch_name",
                        "storageKey": null
                      },
                      {
                        "alias": "sheet_id",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "page_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Box",
                        "kind": "LinkedField",
                        "name": "boxes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "x",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "y",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "audio_file_download_url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "midi_file_download_url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicSheet",
                "kind": "LinkedField",
                "name": "sheets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnail_download_url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6ea34b3a0e7885ce11061a6b6689a80",
    "id": null,
    "metadata": {},
    "name": "UpdatePieceFileChangeMIDINoteAndStartMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePieceFileChangeMIDINoteAndStartMutation(\n  $input: MusicUpdatePieceFileChangeMIDINoteAndStartInput!\n) {\n  music_update_piece_file_change_midi_note_and_start(input: $input) {\n    piece {\n      id\n      ...PiecePlayBody_piece\n    }\n  }\n}\n\nfragment Export_Piece on MusicPiece {\n  id\n  file {\n    version\n    midi_file_download_url\n    audio_file_download_url\n  }\n}\n\nfragment ListenPlayer_Piece on MusicPiece {\n  id\n  ...PieceRenderer_piece\n  ...PieceRendererStepThru_piece\n  file {\n    audio_file_download_url\n    duration\n    notes {\n      bulb_id\n      note_start\n      note_duration\n      midi_number\n    }\n  }\n}\n\nfragment OnSheetNoteByNotePlayer_Piece on MusicPiece {\n  id\n  file {\n    notes {\n      bulb_id\n      midi_number\n      left_handed\n      note_start\n    }\n  }\n  ...SheetRenderer_piece\n}\n\nfragment PiecePlayBody_piece on MusicPiece {\n  id\n  ...ListenPlayer_Piece\n  ...SimplifiedNoteByNotePlayer_Piece\n  ...OnSheetNoteByNotePlayer_Piece\n  ...Export_Piece\n}\n\nfragment PieceRendererNoteChangeDuration_note on MusicPieceFileNote {\n  bulb_id\n  note_duration\n}\n\nfragment PieceRendererNoteTooltip_note on MusicPieceFileNote {\n  page_id\n  note_id\n  bulb_id\n  midi_number\n  note_start\n  note_duration\n  ...PieceRendererViewAttributes_note\n  ...PieceRendererNoteChangeDuration_note\n}\n\nfragment PieceRendererNote_note on MusicPieceFileNote {\n  bulb_id\n  note_start\n  midi_number\n  note_duration\n  ...PieceRendererNoteTooltip_note\n}\n\nfragment PieceRendererStepThruNote_note on MusicPieceFileNote {\n  bulb_id\n  note_duration\n  note_start\n  midi_number\n}\n\nfragment PieceRendererStepThru_piece on MusicPiece {\n  id\n  file {\n    notes {\n      bulb_id\n      note_duration\n      note_start\n      midi_number\n      ...PieceRendererStepThruNote_note\n    }\n  }\n}\n\nfragment PieceRendererViewAttributes_note on MusicPieceFileNote {\n  note_id\n  bulb_id\n  midi_number\n  pitch_name\n  left_handed\n  note_start\n}\n\nfragment PieceRenderer_piece on MusicPiece {\n  id\n  output_storage_name\n  file {\n    notes {\n      bulb_id\n      left_handed\n      note_start\n      ...PieceRendererNote_note\n    }\n  }\n}\n\nfragment SheetRendererNoteBox_box on Box {\n  x\n  y\n  width\n  height\n}\n\nfragment SheetRendererNote_note on MusicPieceFileNote {\n  bulb_id\n  sheet_id: page_id\n  boxes {\n    ...SheetRendererNoteBox_box\n  }\n}\n\nfragment SheetRenderer_piece on MusicPiece {\n  id\n  file {\n    notes {\n      bulb_id\n      ...SheetRendererNote_note\n    }\n  }\n  sheets {\n    id\n    width\n    height\n    thumbnail_download_url\n  }\n}\n\nfragment SimplifiedNoteByNotePlayer_Piece on MusicPiece {\n  id\n  ...PieceRenderer_piece\n  ...PieceRendererStepThru_piece\n  file {\n    notes {\n      left_handed\n      note_start\n      bulb_id\n      midi_number\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07fdf422bbe01b033a7a83d866a209ab";

export default node;
